export default "__VITE_ASSET__0d4af395__"